import { render, staticRenderFns } from "./BusinessLayout.vue?vue&type=template&id=31c3e748&"
import script from "./BusinessLayout.vue?vue&type=script&lang=js&"
export * from "./BusinessLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports